<!-- 绘画列表页 -->
<template>
  <div class="component-header">
    <div class="banner" v-loading="loading">
      <div class="detailtitle">{{ detail.Name }}</div>
      <div class="detailinfo">
        作者：{{ detail.Author }} /{{ detail.Province }}
      </div>
      <div class="detailimg">
        <img
          :src="
            'https://oss.oact.net/' +
              detail.Cover +
              '?x-oss-process=image/resize,w_1200,/format,jpg/quality,Q_60'
          "
          v-if="leftNavIndex != 1"
        />
        <div class="contents" v-html="detail.Detail"></div>
      </div>
      <div class="toupiao">
        <!-- <div class="newnums">
          当前票数：<span class="rtnums">{{
            detail.VoteNum > 0 ? numberFormat(detail.VoteNum) : 0
          }}</span>
        </div>
        <button class="dotou" @click="open(detail.Url)">我要投票</button> -->
      </div>
    </div>
    <div class="ptankuang" v-show="tankuang">
      <div class="ctankuang">
        <div class="tishititle" style="color:red;text-align:center;">
          温馨提示
        </div>
        <div id="qrcode"></div>
        <div class="btnssss">
          <div class="tishiwenzi">请使用微信扫码投票</div>
          <el-button @click="closetankuang()">关 闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getInfo } from "@/api/datas";
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  name: "ComponentHeader",
  data() {
    return {
      isphone: false,
      loading: true,
      tankuang: false,
      detaildata: {
        id: 1,
        title: "文章测试标题测试标题测试标题测试标",
        img: "../assets/images/toupiao/hhlistimg.png",
        author: "高小飞",
        addr: "河北省",
        nums: "123456",
        links: "http://www.baidu.com"
      },
      detail: {},
      //文章列表数据
      wzlist: [
        {
          id: 1,
          title:
            "文章测试标题测试标题测试标题测试标题绘画测试标题测试标题测试标题测试标题",
          imgs: "/assets/images/toupiao/hhlistimg.png",
          author: "高小飞",
          addr: "河北省",
          nums: "123456",
          links: "http://www.baidu.com"
        },
        {
          id: 1,
          title: "测试标题测试标题测试标题测试标题",
          imgs: "../assets/images/toupiao/hhlistimg.png",
          author: "高大飞",
          addr: "河北省",
          nums: "15560",
          links: "http://www.baidu.com"
        },
        {
          id: 1,
          title: "测试标题测试标题测试标题测试标题",
          imgs: "../assets/images/toupiao/hhlistimg.png",
          author: "高小飞",
          addr: "河北省",
          nums: "132815",
          links: "http://www.baidu.com"
        },
        {
          id: 1,
          title: "测试标题测试标题测试标题测试标题",
          imgs: "../assets/images/toupiao/hhlistimg.png",
          author: "高中飞",
          addr: "河北省",
          nums: "495845",
          links: "http://www.baidu.com"
        },
        {
          id: 1,
          title: "测试标题测试标题测试标题测试标题",
          imgs: "../assets/images/toupiao/hhlistimg.png",
          author: "高上飞",
          addr: "河北省",
          nums: "495845",
          links: "http://www.baidu.com"
        }
      ],
      // 文章类	  97969	 r9ekyf
      // 绘画类	  97972	 ads1fy
      // 摄影类	  97970	 8bcvxl
      // 微视频类	97971	 6pbmul
      menudatatype: [
        // 服务器上的类型的信息
        {},
        { name: "文章类", ActivityId: 97969, Prefix: "r9ekyf" },
        { name: "绘画类", ActivityId: 97972, Prefix: "ads1fy" },
        { name: "摄影类", ActivityId: 97970, Prefix: "8bcvxl" },
        { name: "微视频类", ActivityId: 97971, Prefix: "6pbmul" }
      ]
    };
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex", // 当前激活的导航菜单的下标
      "leftNavIndex" //四个类型的作品类型下标
    ])
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
    var menutype = this.$route.query.type;
    var detailid = this.$route.query.id;
    // 获取数据列表
    this.getDetail(menutype, detailid);
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 获取作品详情页
     * ##########################################################################################
     */

    getDetail(menutype, detailid) {
      // TODO: request login api
      this.loading = true;
      var res = [];
      var data = {
        Id: detailid,
        ActivityId: this.menudatatype[menutype]["ActivityId"],
        Prefix: this.menudatatype[menutype]["Prefix"]
      };

      getInfo(data).then(res => {
        if (res.Msg == "success") {
          this.total = res.total;
          this.detail = res.Data;
          this.loading = false;
        } else {
          this.$message.error(res.Msg);
          this.loading = false;
        }
      });
      /*
      // 测试代码
      this.detail = this.detaildata;
      // 数据列表
      // getDeedsdatas(this.menutype).then(res => {
      //   this.total = res.length;
      //   this.nameList = res.slice(
      //     (this.current - 1) * this.size,
      //     this.current * this.size
      //   );
      //   this.loading = false;
      // });
      setTimeout(() => {
        this.loading = false;
      }, 2000);*/
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    },
    open(url) {
      if (this.isMobile()) {
        window.open(url);
      } else {
        this.stop();
        $("#qrcode").html("");
        this.qrcode(url);
        this.tankuang = true;
      }
    },
    closetankuang() {
      this.tankuang = false;
      this.move();
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 180,
        height: 180,
        text: url // 二维码地址
      });
      console.log("qrcode：", qrcode);
    },
    //禁止滚动
    stop() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    move() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
/* 弹框 */
.ptankuang {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ctankuang {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: 430px;
  margin: 0 auto;
  position: absoulte;
  top: 50%;
  left: 50%;
  margin-top: 15%;
}
/* 提示大标题 */
.tishititle {
  position: relative;
  top: 30px;
  font-size: 20px;
}
/* 二维码提示文字 */
.tishiwenzi {
  font-size: 16px;
  margin-bottom: 5px;
}
/* 二维码图片 */
#qrcode {
  /* padding-left: 150px;
  padding-top: 50px; */
  width: 100%;
  height: 200px;
  position: relative;
  top: 50px;
  text-align: center;
}
/* 关闭二维码弹框 */
.btnssss {
  width: 100%;
  position: relative;
  /* top: 50px; */
  text-align: center;
  /* margin-top: 20px; */
  bottom: -100px;
}
/* 暂无数据是的样式 */
.empty {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 120px 0;
  background-color: rgba(255, 255, 255, 0.5);
}
.component-header {
  position: relative;
  min-width: 1200px;
  margin-top: 50px;
}
.titlehang1 {
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.active {
  background-color: var(--main-color);
  color: #fff;
}
.banner {
  width: 100%;
  padding-bottom: 500px;
  font-family: "思源宋体";
}
.banner .detailtitle {
  font-size: 48px;
  color: var(--main-color);
  line-height: 1.3em;
}
.banner .detailinfo {
  font-size: 18px;
  height: 18px;
  line-height: 18px;
  position: relative;
  top: 36px;
}
.banner .detailimg {
  position: relative;
  top: 100px;
}
.banner .detailimg img {
  width: 100%;
  margin-bottom: 20px;
}
.banner .detailimg .contents {
  font-size: 22px;
  font-family: "思源宋体" !important;
  line-height: 1.8em;
  /* text-indent: 2em; */
  text-align: justify;
}
.banner .toupiao {
  position: relative;
  width: 560px;
  top: 200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.banner .toupiao .newnums {
  width: 260px;
  height: 45px;
  font-size: 22px;
  font-family: "微软雅黑";
  line-height: 45px;
  text-align: center;
  float: left;
  border-radius: 5px;
  border: solid 2px #e5b7af;
}
.banner .toupiao .newnums .rtnums {
  color: var(--main-color);
  font-size: 25px;
  height: 25px;
  line-height: 25px;
  font-weight: 600;
}
.banner .toupiao .dotou {
  position: relative;
  background-color: aquamarine;
  height: 45px;
  width: 260px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background-color: var(--main-color);
  font-size: 28px;
  font-weight: 600;
  font-family: "思源黑体";
}
.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  height: 52px;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 16px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}

.navs {
  width: 100%;
  height: 58px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(109, 3, 4, 0.9);
  z-index: 20;
}

.navs .main-content {
  height: 100%;
  display: flex;
}

.navs .link {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.4s;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 16px;
  position: relative;
}

.navs .link:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.navs .link::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  left: 0;
  top: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s;
}

.navs .link:hover {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link:hover::after {
  opacity: 1;
  transform: scale(1);
}

.navs .link.active {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link.active::after {
  opacity: 1;
  transform: scale(1);
}

.has-login-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.has-login-wrapper .link-mine {
  color: #f7f17d;
  font-weight: bold;
  margin-right: 16px;
}

.has-login-wrapper .userinfo {
  display: flex;
  align-items: center;
}

.has-login-wrapper .avatar {
  width: 48px;
  height: 48px;
  border: 2px solid #fbd48b;
  margin-right: 8px;
  cursor: pointer;
}

.has-login-wrapper .nickname {
  color: #ffffff;
}
.has-login-wrapper .logouts {
  color: #bb1515;
  border: solid 1px #ef7878;
  padding: 3px;
  background-color: #eae3b6;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.has-login-wrapper .logouts:hover {
  color: #e72c2c;
}
.has-login-wrapper .logouts:active {
  color: #9b2020;
}
</style>



// WEBPACK FOOTER //
// src/components/hhdetail.vue